import { render } from "./index.vue?vue&type=template&id=14e47c51&scoped=true&bindings={}"
import script from "./albums-info.js?vue&type=script&lang=js"
export * from "./albums-info.js?vue&type=script&lang=js"

import "./albums-info.scss?vue&type=style&index=0&id=14e47c51&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14e47c51"

export default script